<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-text-field v-model="data['name']" solo flat label="Slide Name" />
    </v-layout>
    <v-layout>
      <v-textarea v-model="data['keyMessage']" auto-grow solo flat counter label="Slide Key Message" />
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'AddSlideForm',
  props: ['data'],
  data() {
    return {
      values: {}
    };
  },
  watch: {
    /* 'values': {
        handler(values) {
          if (values.name.length > 0) {
            this.canSubmit();
          }
        },
        deep: true
      }*/
  },
  methods: {
    sendData() {
      return this.$emit('data-dialog', this.values);
    },
    canSubmit() {
      this.$emit('canSubmit', true);
    }
  }
};
</script>

<style scoped></style>
